import React, { useEffect } from 'react'
import { useRedirect } from '../../utils/useRedirect'

export const Redirect: React.FC = React.memo(({ children }) => {
    const { redirectTo } = useRedirect()

    const handleRedirect = async () => {
        redirectTo()
    }

    useEffect(() => {
        handleRedirect()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <>{children}</>
})
